var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-form-section",
    { staticClass: "relative" },
    [
      _c("p", { staticClass: "mat16" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.say.two_factor_auth_description ||
                "Zabezpiecz konto administratora kodem z aplikacji Google Authenticator."
            ) +
            " "
        ),
      ]),
      _c("p", { staticClass: "mat16" }, [
        _vm.enabled
          ? _c("b", [
              _vm._v(
                " " +
                  _vm._s(_vm.say.two_factor_enabled || "2FA jest włączone") +
                  " "
              ),
            ])
          : _c("b", [
              _vm._v(
                " " +
                  _vm._s(_vm.say.two_factor_disabled || "2FA jest wyłączone") +
                  " "
              ),
            ]),
      ]),
      _vm.enabled
        ? _c("base-notification-local", {
            staticClass: "two-factor-warning",
            attrs: { negative: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.say.two_factor_logout_warning_title ||
                              "Uwaga — ryzyko utraty dostępu"
                          ) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.say.two_factor_logout_warning ||
                              "Jeśli wylogujesz się bez wcześniejszego połączenia konta z Google Authenticator (skan QR lub wpisanie sekretu), stracisz dostęp do konta administratora."
                          ) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1028605190
            ),
          })
        : _vm._e(),
      _vm.actionError
        ? _c("p", { staticClass: "error error--show mat16" }, [
            _vm._v(" " + _vm._s(_vm.actionError) + " "),
          ])
        : _vm._e(),
      _vm.enabled && (_vm.secret || _vm.qrObjectUrl)
        ? _c("div", { staticClass: "two-factor-setup mat24" }, [
            _c("p", { staticClass: "mat16" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.say.two_factor_setup_warning ||
                      "Zapisz sekret lub zeskanuj QR teraz. Przy następnym logowaniu będzie wymagany kod z aplikacji."
                  ) +
                  " "
              ),
            ]),
            _vm.secret
              ? _c("p", { staticClass: "mat16" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.say.two_factor_secret || "Sekret (wpis ręczny)"
                      ) + ":"
                    ),
                  ]),
                  _c("code", { staticClass: "two-factor-setup__secret" }, [
                    _vm._v(_vm._s(_vm.secret)),
                  ]),
                ])
              : _vm._e(),
            _vm.qrObjectUrl
              ? _c("div", { staticClass: "mat16" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.say.two_factor_scan_qr ||
                          "Zeskanuj kod QR w aplikacji Google Authenticator"
                      )
                    ),
                  ]),
                  _c("img", {
                    staticClass: "two-factor-setup__qr",
                    attrs: { src: _vm.qrObjectUrl, alt: "QR code 2FA" },
                  }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c("div", { staticClass: "row mat24" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-4" },
          [
            !_vm.enabled
              ? _c(
                  "base-button",
                  {
                    attrs: { btn1: "", disabled: _vm.loading },
                    on: {
                      click: function ($event) {
                        return _vm.enable2FA()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.say.enable_2fa || "Włącz 2FA") + " "
                    ),
                  ]
                )
              : _c(
                  "base-button",
                  {
                    attrs: { btn6: "", disabled: _vm.loading },
                    on: {
                      click: function ($event) {
                        return _vm.disable2FA()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.say.disable_2fa || "Wyłącz 2FA") + " "
                    ),
                  ]
                ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }